import { render, staticRenderFns } from "./products_detail.vue?vue&type=template&id=6185657c&scoped=true"
import script from "./products_detail.vue?vue&type=script&lang=js"
export * from "./products_detail.vue?vue&type=script&lang=js"
import style0 from "./products_detail.vue?vue&type=style&index=0&id=6185657c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6185657c",
  null
  
)

export default component.exports